import { TFunction } from "react-i18next";

import { StorageBox } from "../models/storage.box";

export const getCurrentLocationStorageBox = (
  storageBox: StorageBox,
  translate: TFunction<"translation", undefined>
) => {
  if (storageBox?.mapCells && storageBox?.mapCells?.length > 0) {
    return storageBox?.mapCells[0]?.name || "";
  }

  if (
    storageBox?.lastMovedAt &&
    ((storageBox?.mapCells && storageBox?.mapCells?.length === 0) || !storageBox?.mapCells)
  ) {
    return translate("unknown");
  }

  if (!storageBox?.lastMovedAt) return translate("empty");

  return "";
};
